import routes from './routes';

const config = {
    routes,
    MAIN_API: 'https://api.ae6789.sbs',
};

export default config;
